<template>
  <div>
    <div class="time-box" @click="show = true">
      <span class="time-text">{{date}}</span>
      <img class="down-img" src="../../../assets/images/sjx_down.png" />
    </div>
    <!-- 时间组件开始 -->
    <van-calendar
      color="#29BEBC"
      v-model="show"
      @confirm="onConfirm"
      :show-title="false"
      :show-confirm="false"
      :min-date="minDate"
      :max-date="maxDate"
    />
    <!-- 时间组件结束 -->
  </div>
</template>
<script type="text/ecmascript-6">
import { toast } from "@/common/api/api.js";
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      date: moment(this.centralControl.utils.obtainEast8Date()).format(
        "YYYY-MM-DD"
      ),
      show: false,
      minDate: new Date(2019, 0, 1),
      maxDate:"",
    };
  },
  watch: {
    date(val) {
      this.$emit("changeDate", val);
    }
  },
  mounted() {
  },
  created(){
     this.init();
  },
  methods: {
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    // 自定义时间
    defineTime() {
      let todayTime = this.date.split("-");
      this.maxDate = new Date(
        parseInt(todayTime[0]),
        parseInt(todayTime[1]-1),
        parseInt(todayTime[2])
      );
    },
    onConfirm(date) {
      this.show = false;
      this.date = this.formatDate(date);
    },
    init() {
      this.defineTime();
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../../assets/stylus/common.styl';

.time-box {
  text-align: center;
  margin: 20px auto 10px;
  position: absolute;
  width: 100%;
  top: 1px;
}

.time-text {
  height: 20px;
  line-height: 20px;
  vertical-align: middle;
  stepTextStyle();
}

.down-img {
  width: 25px;
  vertical-align: middle;
  margin-left: 4px;
  display: inline-block;
}
</style>